export var warnDisabledConflict = (disabled, ariaDisabled, warned) => {
  if (process.env.NODE_ENV === 'development' && !warned && disabled === true && (ariaDisabled === 'true' || ariaDisabled === true)) {
    console.warn('@veneer/core: The props `disabled` and `aria-disabled` are mutually exclusive. Please use one or the other.');
  }
  return true;
};